var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return !_vm.isAPP && !_vm.isMini && !_vm.isAlipayMini && (_vm.weChatId == 302 || _vm.weChatId == 421 || _vm.weChatId == 434 || _vm.weChatId == 1) ? _c('div', {
    staticClass: "component-app-download",
    class: {
      'hide-transition': !_vm.showAppDownload,
      'inWeiXin': _vm.isWX && _vm.pageType == 4
    }
  }, [_c('i', {
    staticClass: "btn-close",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.closeLayer.apply(null, arguments);
      }
    }
  }), _c('ycf-image', {
    staticClass: "yunkezan-logo",
    attrs: {
      "src": "/srcv2/images/ykz_app_icon.png"
    }
  }), _vm._m(0), _vm._m(1)], 1) : _vm._e();
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "txt-content"
  }, [_c('p', {
    staticClass: "txt-h"
  }, [_vm._v("云客赞APP")]), _c('p', {
    staticClass: "txt-p"
  }, [_vm._v("旅游 / 美食 / 生活全都省")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "btn-download-border"
  }, [_c('div', {
    staticClass: "btn-download-content"
  }, [_c('i', [_vm._v("立即打开")])])]);
}];
export { render, staticRenderFns };